var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',{attrs:{"x-small":""},on:{"click":_vm.copy}},[_vm._v("mdi-content-copy")])]}}]),model:{value:(_vm.showCopied),callback:function ($$v) {_vm.showCopied=$$v},expression:"showCopied"}},[_c('div',{staticClass:"text-caption"},[_vm._v("Copied to clipboard")])])}
var staticRenderFns = []

export { render, staticRenderFns }